"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StreamJoinForm = require("./StreamJoinForm");
Object.keys(_StreamJoinForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StreamJoinForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StreamJoinForm[key];
    }
  });
});